import { render, staticRenderFns } from "./purchase_order_edit.vue?vue&type=template&id=4ff67976&scoped=true"
import script from "./purchase_order_edit.vue?vue&type=script&lang=js"
export * from "./purchase_order_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff67976",
  null
  
)

export default component.exports